/* eslint-disable no-underscore-dangle */

/**
 * 给 computed 里用的，示例：
 * ```
 * computed: {
 *   ...injectFields("uc", [
 *     "pagelet",
 *     "components",
 *   ]),
 *   otherComputed() { return this.xxx },
 * }
 * ```
 *
 * @param {string} parentName
 * @param {string[]} fieldNames
 * @returns {Record<string, Vue.ComputedOptions>}
 */
export function injectFields(parentName, fieldNames) {
  const ans = {};
  fieldNames.forEach(k => {
    ans[k] = {
      get() {
        return this[parentName][k];
      },
      set(v) {
        this[parentName][k] = v;
      }
    };
  });
  return ans;
}

/**
 * 给 methods 里用的，示例：
 * ```
 * methods: {
 *   ...injectFields("designer", [
 *     "setHoveringCompPath",
 *     "compFromPoint",
 *   ]),
 *   otherMethod() { },
 * }
 * ```
 *
 * @param {string} parentName
 * @param {string[]} methodNames
 * @returns {Record<string, Function>}
 */
export function injectMethods(parentName, methodNames) {
  const ans = {};
  methodNames.forEach(k => {
    ans[k] = function (...args) {
      return this[parentName][k](...args);
    };
  });
  return ans;
}
//# sourceMappingURL=injectFromParent.js.map
